var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
                    name: _vm.$t('sideMenu.myApps'),
                    icon: 'ai ai-apps text-primary',
                    path: '/applications',
                }}}),_c('sidebar-item',{attrs:{"link":{
                    name: _vm.$t('sideMenu.myAccount'),
                    icon: 'ai ai-account text-warning',
                    path: '/my-account',
                }}}),(_vm.user.role === 'admin')?_c('sidebar-item',{attrs:{"link":{
                    name: _vm.$t('sideMenu.logs'),
                    icon: 'ai ai-logs text-warning',
                    path: '/logs',
                }}}):_vm._e()]}}])},[(_vm.user.role === 'admin')?_c('template',{slot:"hotel-settings"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("\n                "+_vm._s(_vm.$t("sideMenu.hotelSettings"))+"\n            ")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.invoices'),
                        icon: 'ai ai-docs text-warning',
                        path: '/invoices',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.contacts'),
                        icon: 'ai ai-docs text-warning',
                        path: '/contacts',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.hotelTags'),
                        icon: 'ai ai-docs text-warning',
                        path: '/hotel-tags',
                    }}})],1)]):_vm._e(),(_vm.user.role === 'admin')?_c('template',{slot:"user-management"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("\n                "+_vm._s(_vm.$t("sideMenu.userManagement"))+"\n            ")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.inviteNewUser'),
                        icon: 'ai ai-user-add text-pink',
                        path: '/invite-user',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.users'),
                        icon: 'ai ai-user-edit text-info',
                        path: '/users',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.managePermissions'),
                        icon: 'ai ai-user-star text-success',
                        path: '/manage-permissions',
                    }}})],1)]):_vm._e(),(!!_vm.user.assist_admin)?_c('template',{slot:"assist-admin"},[_c('hr',{staticClass:"my-3"}),_c('h6',{staticClass:"navbar-heading p-0 text-muted"},[_vm._v("Assist Admin")]),_c('ul',{staticClass:"navbar-nav mb-md-3"},[_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.manageHotelGroups'),
                        icon: 'ai ai-hotel-group text-primary',
                        path: '/assist-admin/hotel-groups',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.manageHotels'),
                        icon: 'ai ai-hotel text-yellow',
                        path: '/assist-admin/hotels',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.manageApplications'),
                        icon: 'ai ai-apps-2 text-danger',
                        path: '/assist-admin/applications',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.manageInvoices'),
                        icon: 'ai ai-apps-2 text-danger',
                        path: '/assist-admin/invoices',
                    }}}),_c('sidebar-item',{attrs:{"link":{
                        name: _vm.$t('sideMenu.tagManagement'),
                        icon: 'ai ai-apps-2 text-danger',
                        path: '/assist-admin/tag-management',
                    }}})],1)]):_vm._e()],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }